var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconfeatherArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.662,
    height: 27.662,
    viewBox: "0 0 27.662 27.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-up-right",
    "data-name": "Icon feather-arrow-up-right",
    transform: "translate(2.828 2.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M32.5,32.5l-22-22",
    transform: "translate(-10.5 -10.5)",
    fill: "none",
    stroke: "#00f3f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M32.5,10.5h-22v22",
    transform: "translate(-10.5 -10.5)",
    fill: "none",
    stroke: "#00f3f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherArrowUpRight);
export default __webpack_public_path__ + "static/media/Iconfeather-arrow-up-right.5e982921b927bfe26f62f61110b42b64.svg";
export { ForwardRef as ReactComponent };